import { axios } from '@/lib/axios'
import { useQuery } from '@tanstack/react-query'
import { Project } from '../types'

const getProjectByCategory = (categoryId: string): Promise<Project[]> => {
  return axios.get(`/projects/all?categoryId=${categoryId}`)
}

export const useProjectByCategory = (categoryId: string) => {
  return useQuery({
    queryKey: ['projects', categoryId],
    queryFn: () => getProjectByCategory(categoryId),
  })
}
